import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";

// Shared warning "hard cap of 3 needs per week reached",
// shown both in the needs step and on the "create a need" toggle of a qualif.
const FafBudgetWarning = () => (
  <Typography
    type="p"
    className="faf-help faf-help--warn text-3"
    label={
      <FormattedMessage
        id="tools_manager_faf_need_budget_reached"
        defaultMessage="Limite de 3 besoins pour cette semaine atteinte."
      />
    }
  />
);

export default FafBudgetWarning;
